export default {
  namespaced: true,
  state: {
    language: 'en'
  }
}